/** Layout tokens for the selected-audiences panel and interests picker rows. */
export const SELECTED_AUDIENCES_STYLES = {
  fontFamily: `'Work Sans', sans-serif`,
  /** Title */
  titleColor: "#1a202c",
  titleFontSize: "16px",
  titleFontWeight: 600,
  titleLineHeight: 1.3,
  /** Subtitle */
  subtitleColor: "rgba(26, 32, 44, 0.6)",
  subtitleFontSize: "14px",
  subtitleFontWeight: 500,
  subtitleLineHeight: 1.4,
  /** Section stack */
  sectionGapPx: 12,
  /** Card */
  cardBg: "white",
  cardBorder: "2px solid #1d74ff",
  cardRadius: "8px",
  cardPadding: "12px",
  cardGapPx: 24,
  cardShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.05)",
  /** Tag pill */
  tagBg: "#dfeafd",
  tagColor: "rgba(26, 32, 44, 0.8)",
  tagFontSize: "12px",
  tagFontWeight: 500,
  tagLineHeight: 1.4,
  tagRadius: "4px",
  tagPx: "4px",
  tagPy: "2px",
  /** Audience name */
  nameColor: "#2c333e",
  nameFontSize: "16px",
  nameFontWeight: 500,
  nameLineHeight: 1.4,
  /** Tag + name column */
  labelStackGapPx: 6,
  /** Trash / icon control */
  actionBorder: "1px solid #e2e2e2",
  actionBg: "white",
  actionRadius: "10px",
  actionPx: "12px",
  actionPy: "10px",
  actionShadowIcon: "0px 2px 6px 0px rgba(0, 0, 0, 0.05)",
  actionShadowEdit: "0px 2px 3px rgba(0, 0, 0, 0.05)",
  editTextColor: "#1a202c",
  editFontSize: "13px",
  editFontWeight: 500,
  editLineHeight: "19.2px",
  trashIconW: "18px",
  trashIconH: "20px",
  interestSearchResultRowH: "38px",
  interestSearchResultRowPx: "14px",
  interestSearchResultRowRadius: "8px",
  interestListGapPx: 12,
  interestSearchResultTextSize: "16px",
  interestSearchResultTextWeight: 500,
  interestSearchResultTextLineHeight: "19.2px",
  interestSelectedChipBg: "#fafafa",
  interestSelectedChipBorder: "1px solid #e6e6e6",
  interestSelectedChipPx: "12px",
  interestSelectedChipPy: "6px",
  interestSelectedChipRadius: "8px",
  interestSelectedChipGapPx: 8,
  interestSelectedChipsWrapGapPx: 12,
} as const;
